
import MetaGlobal from '../types/negocio/MetaGlobal';
import api from './api';
import BaseService from './BaseService';

class MetaGlobalService extends BaseService<MetaGlobal> {  

  constructor() {
    super('meta-global', api);
  }

  async listarAreas(): Promise<string[]> {
    const response = await api.get('/api/meta-global/areas');
    return response.data;
  }
}

export const metaGlobalService = new MetaGlobalService();